export default __webpack_public_path__ + "static/media/hover-remove-btn.ee60d30b.svg";